import * as Core from '../core';
import * as Modules from '.';

export const routes = [
    {
        exact: false,
        icon: 'fal fa-home',
        name: 'Home',
        path: '/Home',
        private: true,
        component: Core.Home,
    },

    {
        exact: false,
        icon: 'fal fa-bring-forward',
        name: 'Matchmaking',
        path: '/matches',
        private: true,
        component: Modules.Matches,
    },
    {
        exact: false,
        icon: 'fal fa-calendar-week',
        name: 'Events',
        path: '/events',
        private: true,
        component: Modules.Events,
    },
    // {
    //     exact: false,
    //     icon: 'fal fa-handshake',
    //     name: 'Meet',
    //     path: '/Meet',
    //     private: false,
    //     component: Modules.Meet,
    // },
    {
        exact: false,
        icon: 'fal fa-newspaper',
        menuLang: ['pt'],
        name: 'News',
        path: '/news',
        private: true,
        component: Modules.News,
    },
    {
        exact: false,
        icon: 'fal fa-sort-shapes-up',
        name: 'Ranking',
        path: '/ranking',
        private: true,
        component: Modules.Ranking,
    },
    {
        exact: false,
        icon: 'fal fa-rocket',
        name: 'Startup',
        path: '/startup',
        private: true,
        component: Modules.Startup,
    },
    {
        exact: false,
        name: 'Investor',
        path: '/investor',
        private: true,
        component: Modules.Investor,
    },
];
export default routes;
